import { Injectable, inject, signal } from '@angular/core';
import { Overlay, OverlayRef } from '@angular/cdk/overlay';
import { ComponentPortal } from '@angular/cdk/portal';
import { PageLoaderComponent } from '../components/page-loader/page-loader.component'; // Ajuste o path

@Injectable({
  providedIn: 'root'
})
export class PageLoaderService {
  private readonly overlay = inject(Overlay);
  private overlayRef: OverlayRef | null = null;
  private readonly _enabled = signal(false);
  public readonly enabled = this._enabled.asReadonly();

  public setPageLoader(state: boolean): void {
    if (this._enabled() === state) return;

    if (state) {
      this.show();
    } else {
      this.hide();
    }
  }

  private show(): void {
    if (!this.overlayRef) {
      this.overlayRef = this.overlay.create({
        hasBackdrop: true,
        backdropClass: 'page-loader-backdrop',
        panelClass: 'page-loader-panel',
        positionStrategy: this.overlay
          .position()
          .global()
          .centerHorizontally()
          .centerVertically()
      });
    }

    if (!this.overlayRef.hasAttached()) {
      this.overlayRef.attach(new ComponentPortal(PageLoaderComponent));
    }
    this._enabled.set(true);
  }

  private hide(): void {
    if (this.overlayRef && this.overlayRef.hasAttached()) {
      this.overlayRef.dispose();
      this.overlayRef = null;
    }
    this._enabled.set(false);
  }
}
